import { useEffect } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { marcarAbaAtual } from '../../../lib/relatorios';
import { MOD_IDS, type AbaId, type ModId } from '../../../store/types';
import { useCores } from '../../../components/theme';
import Paywall from '../../../screens/Paywall';
import { useMeusGrupos } from '../../../lib/grupos';
import Casa from '../../../screens/Casa';
import Garantias from '../../../screens/Garantias';
import Documentos from '../../../screens/Documentos';
import Financas from '../../../screens/Financas';
import Monitor from '../../../screens/Monitor';
import EmBreve from '../../../screens/EmBreve';
import Estudos from '../../../screens/Estudos';
import EstudosConvidado from '../../../screens/EstudosConvidado';
import { participaDeEstudos } from '../../../lib/estudosGrupo';
import BemEstar from '../../../screens/BemEstar';
import Modulo from '../../../screens/Modulo';
import Escritorio from '../../../screens/Escritorio';
import Scanner from '../../../screens/Scanner';
import PdfEdit from '../../../screens/PdfEdit';
import Diario from '../../../screens/Diario';
import { voltarAoMyPlanner } from '../../../lib/voltarPlanner';
import { TravaAba } from '../../../components/TravaAba';
export { ErrorBoundary } from '../../../components/Falha';

export default function AbaScreen() {
  const { id, item, dia } = useLocalSearchParams<{ id: AbaId; item?: string; dia?: string }>();
  const router = useRouter();
  const { liberada } = useCores();
  // relatórios gerados aqui entram no histórico desta aba (0.53)
  useEffect(() => { marcarAbaAtual(id); return () => marcarAbaAtual('geral'); }, [id]);
  // 0.72 (texto 11a, A): a raiz de toda aba volta SEMPRE ao My Planner (hoje). Antes era router.back(), que pelo
  // histórico das abas ia para a aba visitada antes (ex.: Ajustes, que podia estar presa fora da tela = tela branca).
  const voltar = voltarAoMyPlanner;
  // 0.65 (B11): quem participa de um grupo desta aba (sem ser o administrador) vê de graça o que foi compartilhado
  const grupos = useMeusGrupos().lista;
  const ehMod = (MOD_IDS as string[]).includes(id);
  if (!liberada(id)) {
    if (ehMod && grupos?.some(g => g.aba === id && !g.admin)) return <Modulo key={id + ':convidado'} id={id as ModId} item={item} onBack={voltar} convidado />;
    // 0.71 (texto 09 J): no grupo de estudos, o colega vê na tela só o fichário compartilhado
    if (id === 'estudos' && participaDeEstudos(grupos)) return <EstudosConvidado key="estudos:convidado" item={item} onBack={voltar} />;
    return <Paywall id={id} onBack={voltar} />;
  }
  // texto 10 (D): "Pedir senha ao abrir esta aba" (Ajustes > Abas). O Diário tem a própria senha.
  const tela = conteudo();
  return id === 'diario' ? tela : <TravaAba id={id} onBack={voltar}>{tela}</TravaAba>;

  function conteudo() {
  switch (id) {
    case 'casa': return <Casa item={item} onBack={voltar} />;
    case 'garantias': return <Garantias item={item} onBack={voltar} />;
    case 'financas': return <Financas item={item} onBack={voltar} />;
    case 'documentos': return <Documentos item={item} onBack={voltar} />;
    case 'estudos': return <Estudos item={item} onBack={voltar} />;
    case 'bemestar': return <BemEstar key={(item ?? '') + (dia ?? '')} item={item} dia={dia} onBack={voltar} />;
    case 'monitor': return <Monitor item={item} onBack={voltar} />;
    case 'escritorio': return <Escritorio item={item} onBack={voltar} />;
    case 'scanner': return <Scanner item={item} onBack={voltar} />;
    case 'pdfedit': return <PdfEdit item={item} onBack={voltar} />;
    case 'diario': return <Diario key={item ?? ''} item={item} onBack={voltar} />;
    default: return (MOD_IDS as string[]).includes(id) ? <Modulo key={id} id={id as ModId} item={item} onBack={voltar} /> : <EmBreve id={id} onBack={voltar} />;
  }
  }
}
